<dynamic-table [props]="props">
    <table class="table">
        <thead>
            <tr class="table-header">
                <th id="Number" class="table-header-title">
                    <div class="d-flex align-items-center justify-content-center">
                        {{'payment.number' | translate}}
                        <i class="app-icon icon icon-warning-circle icon-md info-tooltip-trigger ms-1"
                            [ngbTooltip]="infoPayment"
                            tooltipClass="info-payment-tooltip"
                        ></i>
                    </div>
                </th>

                <th id="Date" class="table-header-title">{{'payment.date' | translate}}</th>

                <th id="Type" class="table-header-title">{{'payment.type' | translate}}</th>

                <th id="Value" class="table-header-title">{{'payment.value' | translate}}</th>
            </tr>
        </thead>

        <tbody>
            <ng-container *ngFor="let payment of payments">
                <tr class="row-container ccc ccc-table-row ccc-hover" (click)="navigateToDetailHandler(payment.paymentId)" role="button">
                    <td HJSuppress id="Number" class="column-content number-color">
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="text-ellipsis">{{payment?.number}}</span>
                            <button class="btn copy-clipboard-btn custom-copy-clipboard-btn ms-2" [cdkCopyToClipboard]="payment.number" 
                                (click)="showClipboardNotification($event)">
                                <i class="app-icon icon icon-copy icon-md2"></i>
                            </button>
                        </div>
                    </td>
                    
                    <td HJSuppress id="Date" class="column-content">
                        {{payment?.date | localizedDate}}
                    </td>

                    <td HJSuppress id="Type" class="column-content">
                        {{payment?.type}}
                    </td>

                    <td HJSuppress id="Value" class="column-content">
                        {{payment?.value | number : '1.'}} {{payment?.currencyCode}}
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</dynamic-table>

<ng-template #infoPayment>
    {{'payment.noRef' | translate}}
</ng-template>